import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskCancelled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 11,
			height: 11,
			rx: 5.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 11,
			height: 11,
			rx: 5.5,
			stroke: "#53647E",
			strokeOpacity: .18
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 4L8 8M8 4L4 8",
			stroke: "#515D71",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTaskCancelled;
